"use client"

import { PrintDataFields } from '@repo/types';
import { InventoryService } from '@repo/ui/lib/api/services/inventory.service';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';

// Query key factory for print data
export const printDataQueryKey = (id: number) => [
  'inventaire',
  'print-data',
  id
];

/**
 * Hook for fetching print data for an inventaire by ID
 * Returns formatted data ready for PDF generation (labels resolved, formatted)
 */
export function usePrintData(
  id: number | null | undefined,
  options?: UseQueryOptions<
    PrintDataFields,
    Error,
    PrintDataFields,
    ReturnType<typeof printDataQueryKey>
  >
) {
  const inventoryService = new InventoryService();

  return useQuery({
    queryKey: printDataQueryKey(id!),
    queryFn: () => {
      if (!id) throw new Error('Inventaire ID is required');
      return inventoryService.getPrintData(id);
    },
    enabled: !!id,
    staleTime: 0, // 5 minutes - print data doesn't change often
    gcTime: 0, // 10 minutes
    ...options
  });
}
